export const colors = {
  navy: "#253671",
  orange: "#ED7729",
  green: "#7BA02E",
  black: "#212121",
  teal: "#167587",
  lightGreen: "#D2DFC0",
  red: "#A62A2F",
  pink: "#ED6088",
};
